import React from "react";
import food from "../assets/images/order/food.png";
import add from "../assets/images/restaurants/add.png";
import minus from "../assets/images/restaurants/minus.png";
import pink_plus from "../assets/images/order/pink_plus.png";
import arrow from "../assets/images/order/orange-arrow.png";
import CouponList from "../components/CouponList";
import PaymentMode from "../modal/PaymentMode";

const OrderSummary = () => {
  const items = [
    {
      id: 1,
      name: "Garlic Noodles",
      quantity: 4,
      price: 300,
      image: food,
    },
    {
      id: 2,
      name: "Veg Biryani",
      quantity: 4,
      price: 300,
      image: food,
    },
    {
      id: 3,
      name: "Chicken butter",
      quantity: 4,
      price: 300,
      image: food,
    },
  ];
  const [count, setCount] = React.useState<number>(0);
  const [isCouponListopen, setIsCouponListOpen] =
    React.useState<boolean>(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] =
    React.useState<boolean>(false);

  const handleIncrement = () => {
    const newCount = count + 1;
    setCount(newCount);
    // onCountChange?.(newCount);
  };

  const handleDecrement = () => {
    if (count > 0) {
      const newCount = count - 1;
      setCount(newCount);
      //   onCountChange?.(newCount);
    }
  };

  return (
    <div className="bg-[#FFFFFF] p-[32px] border-t-2 h-[100vh]">
      <h6>Search / Asian Kitchen/ Order Summary</h6>

      <div className="flex h-[90%]">
        <div className="w-[35%] p-6 flex flex-col justify-between">
          <div className="rounded-[15px] border-2 p-[15px]">
            <h6 className="pb-[14px] border-b-2">Order Items {items.length}</h6>
            <div className="pb-[15px] border-b-2">
              {items.map((item, index) => (
                <div
                  key={item.id}
                  // onClick={() => setSelectedOrderIndex(index)}
                  className={`cursor-pointer transition-colors flex justify-between items-center my-[15px]`}
                >
                  <div className="flex justify-center items-center gap-[10px]">
                    <div className="flex items-center ">
                      <img
                        src={item.image}
                        alt="Food Item"
                        className="h-[75px] w-[75px] rounded-[12px]"
                      />
                    </div>
                    <div>
                      <h6 className="text-[#050505] text-center font-Urbanist text-[17px] font-medium leading-[24px]">
                        {item.name}
                      </h6>
                      <p className="text-[#6A6A6A] text-center font-Urbanist text-[17px] font-normal leading-[21px] tracking-[-0.332px]">
                        {item.price} x {item.quantity}
                        <span className="text-[#FF8A00] font-medium ml-[10px]">
                          {item.price * item.quantity}
                        </span>
                      </p>{" "}
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center gap-3">
                      <div
                        className="bg-[#F5F5F5] text-[#FF8A00] rounded-[8px] font-Urbanist font-semibold text-[18px] w-[38px] h-[38px] flex items-center justify-center cursor-pointer"
                        onClick={handleDecrement}
                      >
                        <img
                          src={minus}
                          alt="minus"
                          className="h-[20px] w-[20px]"
                        />
                      </div>
                      <span className="text-white bg-[#FF8A00] font-Urbanist text-[18px] font-semibold text-center rounded-[10px] px-[15px] py-[6px]">
                        {count}
                      </span>
                      <div
                        className="bg-[#F5F5F5] text-[#FF8A00] rounded-[8px] font-Urbanist font-semibold text-[18px] w-[38px] h-[38px] flex items-center justify-center cursor-pointer"
                        onClick={handleIncrement}
                      >
                        <img
                          src={add}
                          alt="add"
                          className="h-[20px] w-[20px]"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-[10px] mt-[15px] cursor-pointer p-[15px] rounded-[9px] justify-center bg-[#F5F5F5]">
              <img
                src={pink_plus}
                alt="Pink Plus"
                className="h-[19px] w-[19px]"
              />
              <p className="text-[#FF8A00] font-medium">Add More Items</p>
            </div>
          </div>

          {/* Get Started Button */}
          <button
            onClick={() => setIsPaymentModalOpen(true)}
            className="w-full flex items-center justify-between py-4 px-6 bg-[#FF8A00] rounded-[150px] cursor-pointer hover:bg-[#5f0289] transition-colors"
          >
            <span className="text-white font-Urbanist text-[20px] font-semibold leading-[140%]">
              Checkout
            </span>
            <div className="h-[42px] w-[42px] flex justify-center items-center bg-white rounded-full">
              <img
                src={arrow}
                alt="right arrow"
                className="h-[41px] w-[30px] stroke-[2.587px] stroke-[#FB8606]"
              />
            </div>
          </button>
        </div>
        <div className="w-[65%]">
          {/* coupon code  */}
          <div className="border-2 rounded-[19px] p-[15px] mt-[22px] flex flex-col gap-[15px]">
            <div className="flex justify-between items-center pb-[15px] border-b-2">
              <p className="text-[#050505] font-Urbanist text-[19px] font-semibold leading-[140%]">
                Coupon Code
              </p>
              <button
                className="text-[#FF8A00] font-Urbanist text-[15px] font-semibold leading-[18px]"
                onClick={() => setIsCouponListOpen(true)}
              >
                5 Available Coupons
              </button>
            </div>
            <div className="flex justify-between items-center px-[15px] py-[10px] rounded-[15px] bg-[#F5F5F5]">
              <input
                type="text"
                className="text-[#050505] font-[17px] font-medium leading-[160%] w-full bg-transparent outline-none pr-[15px]"
              />
              <button className="text-white font-Urbanist text-[15px] font-semibold leading-[18px] px-[15px] py-[9px] rounded-[9px] border-2 border-[#FF8A00] bg-[#FF8A00]">
                Apply
              </button>
            </div>
          </div>

          {/* charge and gst */}
          <div className="border-2 rounded-[19px] mt-[22px] ">
            <div className="p-[15px] flex flex-col gap-[15px]">
              <div className="pb-[15px] border-b-2">
                <p className="text-[#050505] font-Urbanist text-[19px] font-semibold leading-[140%]">
                  Charges & GST
                </p>
              </div>
              <div className="py-[15px] border-b-2 space-y-[10px]">
                <div className="flex justify-between items-center">
                  <p className="text-[#050505] font-Urbanist text-[17px] font-medium leading-[160%]">
                    Subtotal
                  </p>
                  <span>₹ 5,000.05</span>
                </div>
                <div className="flex justify-between items-center">
                  <p className="text-[#050505] font-Urbanist text-[17px] font-medium leading-[160%]">
                    Delivery Charges
                  </p>
                  <span>₹ 40.00</span>
                </div>
                <div className="flex justify-between items-center">
                  <p className="text-[#050505] font-Urbanist text-[17px] font-medium leading-[160%]">
                    Platform Fee
                  </p>
                  <span>₹ 68.40</span>
                </div>
                <div className="flex justify-between items-center">
                  <p className="text-[#050505] font-Urbanist text-[17px] font-medium leading-[160%]">
                    Coupon
                  </p>
                  <span>- ₹ 500.00</span>
                </div>
              </div>

              {/* total */}
              <div className="flex justify-between items-center">
                <p className="text-[#050505] font-Urbanist text-[19px] font-medium leading-[160%]">
                  Total
                </p>
                <span className="text-[#050505] font-Urbanist text-[19px] font-semibold leading-[160%]">
                  ₹ 4142.00
                </span>
              </div>
            </div>
            {/* duddus plus  */}
            <div className="flex justify-between items-center shadow-[0 1.185px 4.738px 0 rgba(229, 229, 229, 0.40)] bg-[#F5F5F5] px-[15px] py-[10px] rounded-b-[15px]">
              <p className="text-[#050505] font-Urbanist text-[13px] font-medium leading-[160%]">
                You <span className="text-[#FF8A00]">saved ₹ 618.20 </span> from
                Duddus, Try Duddus+ for more offers
              </p>
              <button className="px-[9px] py-[9px] rounded-[6px] bg-[#FF8A00] text-white border-2 border-[#FF8A00] font-Urbanist text-[13px] font-semibold leading-[12px]">
                Try Duddus +
              </button>
            </div>
          </div>
        </div>
      </div>
      {isCouponListopen && <CouponList onClose={() => setIsCouponListOpen(false)} />}
      {isPaymentModalOpen && <PaymentMode onClose={() => setIsPaymentModalOpen(false)} />}
    </div>
  );
};

export default OrderSummary;
